import { render, staticRenderFns } from "./goldWithdrawal.vue?vue&type=template&id=4b68261a&scoped=true"
import script from "./goldWithdrawal.vue?vue&type=script&lang=js"
export * from "./goldWithdrawal.vue?vue&type=script&lang=js"
import style0 from "./goldWithdrawal.vue?vue&type=style&index=0&id=4b68261a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b68261a",
  null
  
)

export default component.exports